import type { MetricDefinitionId } from '../../../shared/domain/bi/metrics/types.no-deps'
import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'DELETE', pattern: '/api/bi/metric-definitions/:definitionId' }

type Params = { definitionId: MetricDefinitionId }
type Body = never
type Query = never
type Output = never

export type RemoveMetricDefinitionEndpoint = Endpoint<Params, Body, Query, Output>

export const removeMetricDefinitionRequest = (request: Request, args: RequestArgs<RemoveMetricDefinitionEndpoint>) =>
    request<RemoveMetricDefinitionEndpoint>(route, args)
